var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartOrdering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m469.31 68.36-29.26 292.57h-322.096l-29.26-292.57z",
    fill: "#4abbef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.31 68.36-29.26 292.57h-166.19v-292.57z",
    fill: "#009be5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 109.72c0 60.59-49.12 109.71-109.71 109.71-60.6 0-109.72-49.12-109.72-109.71 0-60.6 49.12-109.72 109.72-109.72 60.59 0 109.71 49.12 109.71 109.72z",
    fill: "#83e470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 109.72c0 60.59-49.12 109.71-109.71 109.71v-219.43c60.59 0 109.71 49.12 109.71 109.72z",
    fill: "#01b763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.7 91.95-57.41 57.41-9.95 9.95-47.47-47.47 21.22-21.21 26.25 26.25 9.95-9.95 36.19-36.19z",
    fill: "#f3fdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.7 91.95-57.41 57.41v-42.43l36.19-36.19z",
    fill: "#d7f3f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.923 275.429h30v30h-30z",
    fill: "#224370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.86 275.43h30v30h-30z",
    fill: "#39689e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.86 275.43h15v30h-15z",
    fill: "#224370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.798 275.429h30v30h-30z",
    fill: "#39689e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.87 393c-.4 11.04 8.47 20.14 19.42 20.14h323.38c.03 0 .04.02.04.04v29.92c0 .02-.01.04-.04.04h-322.52c-27.34 0-50.15-21.83-50.29-49.17-.11-21.65 13.77-40.11 33.1-46.9.02-.01.03-.02.03-.04l-31.7-316.99c-.01-.02-.02-.04-.04-.04h-70.21c-.02 0-.04-.02-.04-.04v-29.92c0-.02.02-.04.04-.04h97.36c.02 0 .03.02.04.04l34.42 344.21c0 .02.02.04.04.04h309.77c.03 0 .04.01.04.04v29.92c0 .02-.01.04-.04.04h-322.87c-10.54 0-19.55 8.18-19.93 18.71z",
    fill: "#39689e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.71 344.33v29.92c0 .02-.01.04-.04.04h-167.81v-30h167.81c.03 0 .04.01.04.04z",
    fill: "#224370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.67 413.14c.03 0 .04.02.04.04v29.92c0 .02-.01.04-.04.04h-167.81v-30z",
    fill: "#224370"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.568,
    cy: 475.429,
    fill: "#4abbef",
    r: 36.571
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.861,
    cy: 475.429,
    fill: "#009be5",
    r: 36.571
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartOrdering);
export default __webpack_public_path__ + "static/media/smart-ordering.ce2ce7819eb12eeecf10d714d239cab9.svg";
export { ForwardRef as ReactComponent };